var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9461 22.0078L11.6961 17.7578L13.0961 16.3578L15.9461 19.2078L21.5961 13.5578L22.9961 14.9578L15.9461 22.0078ZM11.9961 11.0078L19.9961 6.00781H3.99609L11.9961 11.0078ZM11.9961 13.0078L3.99609 8.00781V18.0078H9.14609L11.1461 20.0078H3.99609C3.44609 20.0078 2.97526 19.812 2.58359 19.4203C2.19193 19.0286 1.99609 18.5578 1.99609 18.0078V6.00781C1.99609 5.45781 2.19193 4.98698 2.58359 4.59531C2.97526 4.20365 3.44609 4.00781 3.99609 4.00781H19.9961C20.5461 4.00781 21.0169 4.20365 21.4086 4.59531C21.8003 4.98698 21.9961 5.45781 21.9961 6.00781V10.3578L19.9961 12.3578V8.00781L11.9961 13.0078Z",
    fill: "#7061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCheck);
export default __webpack_public_path__ + "static/media/email_check.c0ab6ef2.svg";
export { ForwardRef as ReactComponent };